
<template>
  <div id="app">
    <appHead v-if="$route.name != 'login' && $route.name != 'union'"></appHead>
	<KeepAlive>
		<router-view v-wechat-title='$route.meta.title' v-if="$route.meta.keepAlive"></router-view>
	</KeepAlive>
	<router-view v-wechat-title='$route.meta.title' v-if="!$route.meta.keepAlive"></router-view>
    <appFoot v-if="$route.name != 'login' && $route.name != 'my' && $route.name != 'union'"></appFoot>
  </div>
</template>

<script>
import appHead from './components/appHead.vue'
import appFoot from './components/appFoot.vue'

export default {
	name: 'app',
	components: {
		appHead,
		appFoot
	}
}
</script>

<style>
	body{
		margin: 0 !important;
		width: 100vw;
		overflow-x: hidden;
	}
	.flex{
		display: flex;
		flex-wrap: wrap;
	}
	.align{
		display: flex;
		align-items: center;
	}
	.end{
		display: flex;
		align-items: flex-end;
	}
	.center{
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.spb{
		display: flex;
		justify-content: space-between;
	}
	.rows {
	    display: flex;
	    flex-direction: row;
	    align-items: center;
	}
	.between {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.column {
	    display: flex;
	    flex-direction: column;
	    align-items: center;
	}
	.reverse{
		display: flex;
		flex-direction: row-reverse;
		align-items: center;
	}
	.crumbs{
        width: 1232px;
        padding: 19px 0;
        margin: 0 auto;
        font: 14px/14px "Microsoft YaHei";
    }
	.pageBox{
		display: flex;
		flex-direction: row-reverse;
		padding-top: 14px;
	}
</style>
